import { ImageLoader } from "next/image";

export const awsLoader: ImageLoader = ({ src, width, quality }) => {
  const srcElements = src.split("/");
  const fileName = srcElements[srcElements.length - 1];

  const key = decodeURIComponent(fileName.replace(/\+/g, " "));

  const params = JSON.stringify({
    bucket: "thickt-manual-uploads",
    key,
    edits: {
      resize: {
        width,
      },
      jpeg: {
        quality,
      },
      webp: {
        quality,
      },
    },
  });

  return `https://d19z0tvyd0zl4j.cloudfront.net/${btoa(params)}`;
};
